/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Org_Add_Member_PersonInputs */

const th_org_add_member_person = /** @type {(inputs: Org_Add_Member_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คนที่อยู่ในระบบแล้ว`)
};

const en_org_add_member_person = /** @type {(inputs: Org_Add_Member_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Somebody already here`)
};

const ja_org_add_member_person = /** @type {(inputs: Org_Add_Member_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すでに登録済みの人`)
};

const zh_org_add_member_person = /** @type {(inputs: Org_Add_Member_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已在这里的人`)
};

const es_org_add_member_person = /** @type {(inputs: Org_Add_Member_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alguien que ya está aquí`)
};

const pt_org_add_member_person = /** @type {(inputs: Org_Add_Member_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alguém que já está aqui`)
};

const id_org_add_member_person = /** @type {(inputs: Org_Add_Member_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seseorang yang sudah di sini`)
};

const fr_org_add_member_person = /** @type {(inputs: Org_Add_Member_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelqu’un déjà présent`)
};

const tl_org_add_member_person = /** @type {(inputs: Org_Add_Member_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Isang narito na`)
};

const vi_org_add_member_person = /** @type {(inputs: Org_Add_Member_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Người đã có ở đây`)
};

const ko_org_add_member_person = /** @type {(inputs: Org_Add_Member_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이미 있는 사람`)
};

const de_org_add_member_person = /** @type {(inputs: Org_Add_Member_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jemand, der schon hier ist`)
};

const ru_org_add_member_person = /** @type {(inputs: Org_Add_Member_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Кто-то, кто уже здесь`)
};

const tr_org_add_member_person = /** @type {(inputs: Org_Add_Member_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaten burada olan biri`)
};

const it_org_add_member_person = /** @type {(inputs: Org_Add_Member_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qualcuno già presente`)
};

const pl_org_add_member_person = /** @type {(inputs: Org_Add_Member_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ktoś, kto już tu jest`)
};

const uk_org_add_member_person = /** @type {(inputs: Org_Add_Member_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Хтось, хто вже тут`)
};

const hi_org_add_member_person = /** @type {(inputs: Org_Add_Member_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई जो पहले से यहाँ है`)
};

const ar_org_add_member_person = /** @type {(inputs: Org_Add_Member_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`شخص موجود هنا`)
};

const ms_org_add_member_person = /** @type {(inputs: Org_Add_Member_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seseorang yang sudah di sini`)
};

const bn_org_add_member_person = /** @type {(inputs: Org_Add_Member_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এখানে আছেন এমন কেউ`)
};

const zh_tw2_org_add_member_person = /** @type {(inputs: Org_Add_Member_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已在這裡的人`)
};

const zh_hk2_org_add_member_person = /** @type {(inputs: Org_Add_Member_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已在這裡的人`)
};

const ur_org_add_member_person = /** @type {(inputs: Org_Add_Member_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`کوئی جو پہلے سے یہاں ہے`)
};

const fa_org_add_member_person = /** @type {(inputs: Org_Add_Member_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`کسی که از پیش اینجاست`)
};

const sw_org_add_member_person = /** @type {(inputs: Org_Add_Member_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mtu aliyepo tayari`)
};

const nl_org_add_member_person = /** @type {(inputs: Org_Add_Member_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iemand die er al is`)
};

/**
* | output |
* | --- |
* | "Somebody already here" |
*
* @param {Org_Add_Member_PersonInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const org_add_member_person = /** @type {((inputs?: Org_Add_Member_PersonInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Org_Add_Member_PersonInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_org_add_member_person(inputs)
	if (locale === "ja") return ja_org_add_member_person(inputs)
	if (locale === "zh") return zh_org_add_member_person(inputs)
	if (locale === "es") return es_org_add_member_person(inputs)
	if (locale === "pt") return pt_org_add_member_person(inputs)
	if (locale === "id") return id_org_add_member_person(inputs)
	if (locale === "fr") return fr_org_add_member_person(inputs)
	if (locale === "tl") return tl_org_add_member_person(inputs)
	if (locale === "vi") return vi_org_add_member_person(inputs)
	if (locale === "ko") return ko_org_add_member_person(inputs)
	if (locale === "de") return de_org_add_member_person(inputs)
	if (locale === "ru") return ru_org_add_member_person(inputs)
	if (locale === "tr") return tr_org_add_member_person(inputs)
	if (locale === "it") return it_org_add_member_person(inputs)
	if (locale === "pl") return pl_org_add_member_person(inputs)
	if (locale === "uk") return uk_org_add_member_person(inputs)
	if (locale === "hi") return hi_org_add_member_person(inputs)
	if (locale === "ar") return ar_org_add_member_person(inputs)
	if (locale === "ms") return ms_org_add_member_person(inputs)
	if (locale === "bn") return bn_org_add_member_person(inputs)
	if (locale === "zh-TW") return zh_tw2_org_add_member_person(inputs)
	if (locale === "zh-HK") return zh_hk2_org_add_member_person(inputs)
	if (locale === "ur") return ur_org_add_member_person(inputs)
	if (locale === "fa") return fa_org_add_member_person(inputs)
	if (locale === "sw") return sw_org_add_member_person(inputs)
	if (locale === "nl") return nl_org_add_member_person(inputs)
	return en_org_add_member_person(inputs)
});